import * as React from 'react';
import useReduxState from 'src/hooks/useReduxState';
import ForecastListingHeader from './ForecastListing/ForecastListingHeader';
import ForecastTable from './ForecastListing/ForecastTable'

const ForecastListing = (props) => {
    const [forecastSearch, setForecastSearch] = useReduxState('', 'setForecastSearch')
    const [clickedSearch, setClickedSearch] = useReduxState(false, 'setClickedSearch')

    const onClear = () => {
        setForecastSearch('')
        setClickedSearch(false)
    }

    return (
        <div className='card'>
            <div className='card-body'>
                {forecastSearch.trim().length > 0 &&
                    <div className='result-wrapper m-b-20'>
                        <span className='result-text font-16 me-3'>Results for <b>“{forecastSearch}”</b></span>
                        <a href={void (0)} className='font-16 font-bold text-blue2'
                            onClick={() => onClear()}>Clear</a>
                    </div>
                }

                <ForecastListingHeader />

                <ForecastTable />
            </div>
        </div>
    );
}

export default ForecastListing;